import { render, staticRenderFns } from "./BlogPost.vue?vue&type=template&id=3f0ff87a&scoped=true"
import script from "./BlogPost.vue?vue&type=script&lang=ts"
export * from "./BlogPost.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0ff87a",
  null
  
)

export default component.exports